/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/* eslint-disable deprecation/deprecation */
import React, { useMemo, useRef } from 'react';
import { UIComponentsProvider } from '@lumahealthhq/ui-components';
import { EThemeKey, getThemeOptions } from '../utils';
import ModulesContext, { createModulesStore } from './ModulesContext';
import SnackbarContextProvider from './SnackbarContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIModulesProvider(_ref) {
  var children = _ref.children,
    navigate = _ref.navigate,
    navigateBack = _ref.navigateBack,
    onOpen = _ref.onOpen,
    productsMap = _ref.productsMap,
    routingMap = _ref.routingMap,
    switchAccount = _ref.switchAccount,
    updateToken = _ref.updateToken,
    messages = _ref.messages,
    onMessage = _ref.onMessage,
    mixed = _ref.mixed,
    themeOptionsProp = _ref.themeOptions,
    _ref$initializeMateri = _ref.initializeMaterial,
    initializeMaterial = _ref$initializeMateri === void 0 ? false : _ref$initializeMateri,
    env = _ref.env,
    envVariables = _ref.envVariables,
    keyEnv = _ref.keyEnv,
    keyAuthToken = _ref.keyAuthToken,
    logger = _ref.logger,
    config = _ref.config,
    locale = _ref.locale,
    setLocale = _ref.setLocale,
    axiosClient = _ref.axiosClient;
  var storeRef = useRef();
  if (!storeRef.current) {
    storeRef.current = createModulesStore({
      routingMap: routingMap,
      productsMap: productsMap,
      navigate: navigate,
      navigateBack: navigateBack,
      switchAccount: switchAccount,
      updateToken: updateToken
    });
  }
  var themeOptions = useMemo(function () {
    return themeOptionsProp || getThemeOptions(EThemeKey.Base);
  }, [themeOptionsProp]);
  return /*#__PURE__*/_jsx(ModulesContext.Provider, {
    value: storeRef.current,
    children: /*#__PURE__*/_jsx(UIComponentsProvider
    // UIComponents
    , {
      messages: messages,
      onMessage: onMessage,
      mixed: mixed
      // UICore
      ,
      themeOptions: themeOptions,
      initializeMaterial: initializeMaterial
      // UIModel
      ,
      env: env,
      keyEnv: keyEnv,
      keyAuthToken: keyAuthToken
      // UIUtils
      ,
      logger: logger,
      config: config,
      locale: locale,
      setLocale: setLocale,
      axiosClient: axiosClient,
      children: /*#__PURE__*/_jsx(SnackbarContextProvider, {
        onOpen: onOpen,
        children: children
      })
    })
  });
}